import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DashboardLayout.css';

interface DashboardLayoutProps {
    onLogout?: () => void;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ onLogout }) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const handleLogout = () => {
        if (onLogout) {
            onLogout();
        }
        localStorage.removeItem('token');
        navigate(`/${i18n.language}/login`);
    };

    const menuItems = [
        {
            id: 'overview',
            path: `/${i18n.language}/dashboard`,
            icon: 'bi-speedometer2',
            label: t('dashboard.title'),
            sublabel: t('dashboard.overview'),
            end: true
        },
        {
            id: 'favorites',
            path: `/${i18n.language}/dashboard/favorites`,
            icon: 'bi-bookmark-star',
            label: t('dashboard.favorites'),
            sublabel: t('dashboard.saved')
        },
        {
            id: 'subscription',
            path: `/${i18n.language}/dashboard/subscription`,
            icon: 'bi-credit-card',
            label: t('dashboard.subscription'),
            sublabel: t('dashboard.billing')
        },
        {
            id: 'profile',
            path: `/${i18n.language}/dashboard/profile`,
            icon: 'bi-person-circle',
            label: t('dashboard.profile'),
            sublabel: t('dashboard.settings')
        }
    ];

    return (
        <div className="dashboard-layout">
            <div className="container-fluid">
                <div className="row">
                    {/* Sidebar */}
                    <aside className="dashboard-sidebar col-lg-3 col-xl-2">
                        <div className="sidebar-content">

                            <nav className="sidebar-nav">
                                {menuItems.map(item => (
                                    <NavLink
                                        key={item.id}
                                        to={item.path}
                                        end={item.end}
                                        className={({ isActive }) =>
                                            `sidebar-nav-item ${isActive ? 'active' : ''}`
                                        }
                                    >
                                        <i className={`bi ${item.icon}`}></i>
                                        <div className="nav-item-text">
                                            <span className="nav-label">{item.label}</span>
                                            <span className="nav-sublabel">{item.sublabel}</span>
                                        </div>
                                    </NavLink>
                                ))}

                                <div className="sidebar-divider"></div>

                                <button
                                    className="sidebar-nav-item logout-btn"
                                    onClick={handleLogout}
                                >
                                    <i className="bi bi-box-arrow-right"></i>
                                    <div className="nav-item-text">
                                        <span className="nav-label">{t('dashboard.logout')}</span>
                                        <span className="nav-sublabel">{t('dashboard.secureLogout')}</span>
                                    </div>
                                </button>
                            </nav>
                        </div>
                    </aside>

                    {/* Main Content */}
                    <main className="dashboard-main col-lg-9 col-xl-10">
                        <Outlet />
                    </main>
                </div>
            </div>

            {/* Mobile Bottom Navigation */}
            <nav className="dashboard-mobile-nav d-lg-none">
                {menuItems.map(item => (
                    <NavLink
                        key={item.id}
                        to={item.path}
                        end={item.end}
                        className={({ isActive }) =>
                            `mobile-nav-item ${isActive ? 'active' : ''}`
                        }
                    >
                        <i className={`bi ${item.icon}`}></i>
                        <span>{item.label}</span>
                    </NavLink>
                ))}
                <button className="mobile-nav-item logout" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right"></i>
                    <span>{t('dashboard.exit')}</span>
                </button>
            </nav>
        </div>
    );
};

export default DashboardLayout;

